/* IX_SEARCH_RESPONSIVENESS_V2: native Shopify results; bounded, page-local title/link cache. */
(() => {
  if (window.ixPredictiveBound) return;
  window.ixPredictiveBound = true;
  const DEBOUNCE_MS = 120, CACHE_TTL_MS = 20000, CACHE_LIMIT = 20, REQUEST_TIMEOUT_MS = 8000;
  const cache = new Map();
  // No storage, prices, catalog preload, telemetry, or cross-page cached results.
  window.addEventListener('pagehide', () => cache.clear());
  window.addEventListener('pageshow', event => { if (event.persisted) cache.clear(); });

  function init(w) {
    if (w.dataset.p === '1') return;
    const i = w.querySelector('[data-ix-predictive-input]');
    const o = w.querySelector('[data-ix-predictive-results]');
    if (!i || !o) return;
    w.dataset.p = '1';
    let labels = {};
    try { labels = JSON.parse(document.getElementById('ix-search-labels')?.textContent || '{}'); } catch (_) {}
    const label = (key, fallback) => labels[key] || fallback;
    const root = window.Shopify?.routes?.root || '/';
    let timer, controller, requestTimer, sequence = 0, active = -1, composing = false;
    const status = document.createElement('span');
    status.className = 'ix-predictive-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    w.append(status);

    function hide() {
      o.hidden = true;
      o.replaceChildren();
      i.setAttribute('aria-expanded', 'false');
      i.removeAttribute('aria-activedescendant');
      i.removeAttribute('aria-busy');
      o.removeAttribute('aria-busy');
      status.textContent = '';
      active = -1;
    }
    function cancel() {
      ++sequence;
      clearTimeout(timer);
      clearTimeout(requestTimer);
      controller?.abort();
      controller = null;
      hide();
    }
    function option(text, url, all = false, image = null) {
      const a = document.createElement('a');
      a.className = all ? 'ix-predictive__item ix-predictive__all' : 'ix-predictive__item';
      a.href = url;
      if (image) {
        try {
          const src = new URL(image, location.origin);
          if (src.protocol === 'https:' && (src.origin === location.origin || src.hostname === 'cdn.shopify.com')) {
            src.searchParams.set('width', '128');
            const img = document.createElement('img'); img.src = src.href;
            img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy'; a.append(img);
          }
        } catch (_) {}
      }
      const title = document.createElement('span'); title.textContent = text; a.append(title);
      a.id = o.id + '-' + o.children.length;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      o.append(a);
    }
    function show(items, q, message) {
      o.replaceChildren();
      active = -1;
      i.removeAttribute('aria-activedescendant');
      for (const item of items) option(item.title, item.url, false, item.image);
      if (message) {
        const p = document.createElement('p');
        p.setAttribute('role', 'presentation');
        p.textContent = message;
        o.append(p);
      }
      option(label('all', 'عرض جميع النتائج'), root + 'search?' + new URLSearchParams({ q, type: 'product' }), true);
      o.hidden = false;
      i.setAttribute('aria-expanded', 'true');
      status.textContent = message || label('all', 'عرض جميع النتائج');
    }
    function readCache(key) {
      const entry = cache.get(key);
      if (!entry) return null;
      if (Date.now() - entry.at >= CACHE_TTL_MS) { cache.delete(key); return null; }
      cache.delete(key);
      cache.set(key, entry);
      return entry.items;
    }
    function saveCache(key, items) {
      // Empty/error responses are not cached, so a retry always reaches Shopify.
      if (!items.length) return;
      for (const [k, entry] of cache) if (Date.now() - entry.at >= CACHE_TTL_MS) cache.delete(k);
      cache.delete(key);
      cache.set(key, { at: Date.now(), items });
      while (cache.size > CACHE_LIMIT) cache.delete(cache.keys().next().value);
    }
    function search(event) {
      cancel();
      if (composing || event?.isComposing) return;
      const q = i.value.trim();
      if (q.length < 2) return;
      const ticket = sequence, key = root + '\n' + q;
      const cached = readCache(key);
      if (cached) { show(cached, q); return; }
      show([], q, label('loading', 'جارٍ البحث…'));
      i.setAttribute('aria-busy', 'true');
      o.setAttribute('aria-busy', 'true');
      timer = setTimeout(async () => {
        const request = new AbortController();
        controller = request;
        let timedOut = false;
        requestTimer = setTimeout(() => { timedOut = true; request.abort(); }, REQUEST_TIMEOUT_MS);
        try {
          const url = new URL(root + 'search/suggest.json', location.origin);
          url.search = new URLSearchParams({ q, 'resources[type]': 'product,collection', 'resources[limit]': '8' }).toString();
          const response = await fetch(url, { signal: request.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('search');
          const data = await response.json();
          if (ticket !== sequence || i.value.trim() !== q) return;
          const result = data.resources?.results || {}, seen = new Set(), items = [];
          for (const item of [...(result.products || []), ...(result.collections || [])]) {
            if (!item.url || !item.title) continue;
            let u;
            try { u = new URL(item.url, location.origin); } catch (_) { continue; }
            if (u.origin !== location.origin || seen.has(u.pathname)) continue;
            seen.add(u.pathname);
            items.push({ title: item.title, url: u.pathname + u.search, image: typeof item.image === 'string' ? item.image : item.featured_image?.url || null });
          }
          saveCache(key, items);
          show(items, q, items.length ? '' : label('empty', 'لا توجد نتائج مطابقة'));
        } catch (error) {
          if (ticket !== sequence || (error.name === 'AbortError' && !timedOut)) return;
          show([], q, label('error', 'تعذر تحميل الاقتراحات. جرّب البحث في جميع النتائج.'));
        } finally {
          if (ticket === sequence) {
            clearTimeout(requestTimer);
            controller = null;
            i.removeAttribute('aria-busy');
            o.removeAttribute('aria-busy');
          }
        }
      }, DEBOUNCE_MS);
    }
    w.addEventListener('indexes:search-close', cancel);
    i.addEventListener('input', search);
    i.addEventListener('compositionstart', () => { composing = true; cancel(); });
    i.addEventListener('compositionend', () => { composing = false; search(); });
    i.addEventListener('keydown', event => {
      if (event.isComposing || composing) return;
      if (event.key === 'Escape') { cancel(); return; }
      const options = [...o.querySelectorAll('[role=option]')];
      if (o.hidden || !options.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        active = active < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((a, n) => a.setAttribute('aria-selected', String(n === active)));
        i.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView?.({ block: 'nearest' });
      }
      if (event.key === 'Enter' && active >= 0) { event.preventDefault(); options[active].click(); }
    });
    document.addEventListener('click', event => { if (!w.contains(event.target)) cancel(); });
    // Direct Enter remains a native GET; never wait for autocomplete to submit.
    w.querySelector('form')?.addEventListener('submit', cancel);
  }
  const scan = () => document.querySelectorAll('[data-ix-predictive-wrap]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
